import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { PageLoader } from './Loading'

const ProtectedRoute = ({ children, requiredRole = null }) => {
  const { isAuthenticated, loading, isAdmin, isEditor } = useAuth()
  const location = useLocation()

  // Show loading while checking auth status
  if (loading) {
    return <PageLoader message="Checking authentication..." />
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />
  }

  // Admin area is staff-only: authenticated workers go to their portal
  if (!isEditor) {
    return <Navigate to="/workers" replace />
  }

  // Check for required role
  if (requiredRole === 'admin' && !isAdmin) {
    return <Navigate to="/admin" replace />
  }

  return children
}

export default ProtectedRoute
